export function formReset() {
    $('button[type="reset"]').on('click', function () {
        $('button[type="reset"]').removeClass('visible');
        $('input[type="text"]').each((i, input) => {
            $(input).val('');
            $(input).attr('value', '');
        })
    });


    $('input[type="text"]').each((i, input) => {
        const form = $(input).closest('form');
        const resetBtn = form.find('button[type="reset"]');

        if ($(input).val()) {
            resetBtn.addClass('visible');
        }

        $(input).on('input', function () {
            resetBtn.addClass('visible');

            if ($(input).val() === '') {
                resetBtn.removeClass('visible');
            }
        });
    })
}


// WEBPACK FOOTER //
// ./assets/js/modules/formReset.js